// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Client Switcher — styled as nav section ── */

.client-section {
  position: relative;
  z-index: 100;
  margin-bottom: 8px;
}

.client-nav-item {
  cursor: pointer;
  border: none;
  background: none;
  font-family: inherit;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-align: left;
}

/* ── Dropdown ── */

.client-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 4px;
  background: #fff;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow:
    0 4px 12px rgba(0, 0, 0, 0.08),
    0 16px 48px rgba(0, 0, 0, 0.12);
  z-index: 500;
  overflow: hidden;
  animation: clientDropIn 0.15s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes clientDropIn {
  from { opacity: 0; transform: translateY(-4px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Search */
.client-dropdown-search {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 8px 8px 0;
  padding: 8px 12px;
  border-radius: 8px;
  background: var(--bg-primary, #f8f9fa);
  border: 1px solid transparent;
  transition: border-color 0.15s, background 0.15s;
}

.client-dropdown-search:focus-within {
  border-color: rgba(255, 107, 74, 0.3);
  background: #fff;
}

.client-dropdown-search svg {
  color: var(--text-tertiary, #adb5bd);
  flex-shrink: 0;
}

.client-dropdown-search input {
  border: none;
  outline: none;
  font-size: 13px;
  font-family: inherit;
  color: var(--text-primary, #1a1a1a);
  width: 100%;
  background: transparent;
}

.client-dropdown-search input::placeholder {
  color: var(--text-tertiary, #c4c0cc);
}

/* List */
.client-dropdown-list {
  max-height: 320px;
  overflow-y: auto;
  padding: 4px 4px 6px;
  margin-top: 4px;
}

.client-dropdown-list::-webkit-scrollbar { width: 4px; }
.client-dropdown-list::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.07); border-radius: 4px; }

/* Item */
.client-dropdown-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  padding: 9px 12px;
  border: none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  font-family: inherit;
  text-align: left;
  transition: background 0.12s;
}

.client-dropdown-item:hover {
  background: var(--bg-primary, #f8f9fa);
}

.client-dropdown-item.is-active {
  background: rgba(255, 107, 74, 0.06);
}

.client-dropdown-item-name {
  flex: 1 1;
  font-size: 13px;
  font-weight: 500;
  color: var(--text-primary, #1a1a1a);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.client-dropdown-item.is-active .client-dropdown-item-name {
  color: var(--accent-orange, #FF6B4A);
  font-weight: 600;
}

.client-dropdown-item.is-active svg {
  color: var(--accent-orange, #FF6B4A);
}

.client-dropdown-divider {
  height: 1px;
  background: rgba(0, 0, 0, 0.06);
  margin: 2px 12px;
}

.client-dropdown-empty {
  padding: 24px 16px;
  text-align: center;
  font-size: 13px;
  color: var(--text-tertiary, #adb5bd);
}
`, "",{"version":3,"sources":["webpack://./src/styles/advertiser-switcher.css"],"names":[],"mappings":"AAAA,kDAAkD;;AAElD;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,mBAAmB;;AAEnB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC;;mCAEiC;EACjC,YAAY;EACZ,gBAAgB;EAChB,2DAA2D;AAC7D;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;EACtC,6BAA6B;EAC7B,gDAAgD;AAClD;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,mCAAmC;EACnC,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,SAAS;AACT;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA,2CAA2C,UAAU,EAAE;AACvD,iDAAiD,4BAA4B,EAAE,kBAAkB,EAAE;;AAEnG,SAAS;AACT;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,oCAAoC;AACtC","sourcesContent":["/* ── Client Switcher — styled as nav section ── */\n\n.client-section {\n  position: relative;\n  z-index: 100;\n  margin-bottom: 8px;\n}\n\n.client-nav-item {\n  cursor: pointer;\n  border: none;\n  background: none;\n  font-family: inherit;\n  min-width: 0;\n  max-width: 100%;\n  overflow: hidden;\n  text-align: left;\n}\n\n/* ── Dropdown ── */\n\n.client-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  margin-top: 4px;\n  background: #fff;\n  border-radius: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  box-shadow:\n    0 4px 12px rgba(0, 0, 0, 0.08),\n    0 16px 48px rgba(0, 0, 0, 0.12);\n  z-index: 500;\n  overflow: hidden;\n  animation: clientDropIn 0.15s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes clientDropIn {\n  from { opacity: 0; transform: translateY(-4px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n/* Search */\n.client-dropdown-search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 8px 8px 0;\n  padding: 8px 12px;\n  border-radius: 8px;\n  background: var(--bg-primary, #f8f9fa);\n  border: 1px solid transparent;\n  transition: border-color 0.15s, background 0.15s;\n}\n\n.client-dropdown-search:focus-within {\n  border-color: rgba(255, 107, 74, 0.3);\n  background: #fff;\n}\n\n.client-dropdown-search svg {\n  color: var(--text-tertiary, #adb5bd);\n  flex-shrink: 0;\n}\n\n.client-dropdown-search input {\n  border: none;\n  outline: none;\n  font-size: 13px;\n  font-family: inherit;\n  color: var(--text-primary, #1a1a1a);\n  width: 100%;\n  background: transparent;\n}\n\n.client-dropdown-search input::placeholder {\n  color: var(--text-tertiary, #c4c0cc);\n}\n\n/* List */\n.client-dropdown-list {\n  max-height: 320px;\n  overflow-y: auto;\n  padding: 4px 4px 6px;\n  margin-top: 4px;\n}\n\n.client-dropdown-list::-webkit-scrollbar { width: 4px; }\n.client-dropdown-list::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.07); border-radius: 4px; }\n\n/* Item */\n.client-dropdown-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  width: 100%;\n  padding: 9px 12px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  cursor: pointer;\n  font-family: inherit;\n  text-align: left;\n  transition: background 0.12s;\n}\n\n.client-dropdown-item:hover {\n  background: var(--bg-primary, #f8f9fa);\n}\n\n.client-dropdown-item.is-active {\n  background: rgba(255, 107, 74, 0.06);\n}\n\n.client-dropdown-item-name {\n  flex: 1;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-primary, #1a1a1a);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.client-dropdown-item.is-active .client-dropdown-item-name {\n  color: var(--accent-orange, #FF6B4A);\n  font-weight: 600;\n}\n\n.client-dropdown-item.is-active svg {\n  color: var(--accent-orange, #FF6B4A);\n}\n\n.client-dropdown-divider {\n  height: 1px;\n  background: rgba(0, 0, 0, 0.06);\n  margin: 2px 12px;\n}\n\n.client-dropdown-empty {\n  padding: 24px 16px;\n  text-align: center;\n  font-size: 13px;\n  color: var(--text-tertiary, #adb5bd);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
